export function startBillingCheckoutStatusPolling() {
    const container = document.getElementById('billing-checkout-status-poller');

    if (!container) {
        return;
    }

    const statusLabel = document.getElementById('checkout-status-label');
    const intervalMs = Number(container.dataset.intervalMs || 3000);
    const maxAttempts = Number(container.dataset.maxAttempts || 20);
    let attempts = 0;

    const poll = async () => {
        attempts += 1;

        try {
            const response = await window.axios.get(container.dataset.url);

            if (statusLabel) {
                statusLabel.textContent = response.data.label;
            }

            if (response.data.terminal) {
                window.location.reload();
                return;
            }
        } catch (error) {}

        if (attempts < maxAttempts) {
            window.setTimeout(poll, intervalMs);
        }
    };

    window.setTimeout(poll, intervalMs);
}
